<footer class="sens-footer">
  <div class="sens-footer__inner">
    <div class="sens-footer__row sens-footer__row--badges">
      <span class="sens-footer__badge sens-footer__badge--age">18+</span>
      <a [routerLink]="['/documents', 'ai-disclosure']" class="sens-footer__badge sens-footer__badge--ai">
        AI-generated content
      </a>
    </div>

    <nav class="sens-footer__links">
      <a [routerLink]="['/documents']">Documents</a>
      <a [routerLink]="['/documents', 'imprint']">Imprint</a>
      <a [routerLink]="['/documents', 'terms']">Terms</a>
      <a [routerLink]="['/documents', 'privacy']">Privacy</a>
      <a [routerLink]="['/documents', '2257']">2257</a>
      <a [routerLink]="['/documents', 'dmca']">DMCA</a>
      <a [routerLink]="['/documents', 'content-policy']">Content policy</a>
      <a [routerLink]="['/documents', 'moderation']">Moderation</a>
      <a [routerLink]="['/documents', 'refund']">Billing &amp; refund</a>
      <a [routerLink]="['/documents', 'contact']">Contact</a>
    </nav>

    <p class="sens-footer__legal">
      © {{ year }} SENS LTD. Seychelles, registration number 239563. All rights reserved.
    </p>
    <p class="sens-footer__legal">
      Content shown on this site is AI-generated and does not depict real people.
    </p>
  </div>
</footer>
